import firebase from '@firebase/app';
import axios from 'axios';

export const createUser = (uidProfessor, email, password, callback) => {
  return firebase.auth()
    .createUserWithEmailAndPassword(email, password)
    .catch((error) => {

      console.error(error)
      console.log(error.code)

      if (error.code == "auth/email-already-in-use") {

        //Testando se há realmente registro do usuário no firestore
        //pois pode ter havido erro
        //criou a conta nos usuários mas não criou o user no firestore
        firebase.firestore().collection("professors")
          .doc(uidProfessor)
          .collection("users")
          .where("email", "==", email)
          .onSnapshot((snapshot) => {

            console.log("SNAP: ", snapshot.docs);
            //Ainda não há registro portanto houve erro durante a requisição
            if (snapshot.docs == 0) {
              //retorna-se o user normalmente
              axios.get("https://cors-anywhere.herokuapp.com/https://us-central1-app-training-2d29d.cloudfunctions.net/getUidByEmail?email=" + email)
                .then(res => {

                  console.log("AXIOS RES: ", res);
                  if (res != undefined && res != "" && res.data && res.data.uid) {
                    let user = {
                      user: res.data,
                    }

                    console.log("CHAMANDO CALLBACK: ", user);
                    callback(user, true)
                  } else {
                    callback("Email já é utilizado por outro aluno!", false)
                  }

                })

            } else {
              callback("Email já é utilizado por outro aluno!", false);
            }

          }, (error) => {
            console.log('Error getting documents', error);
            callback(error.message, false);
          });


      } else {

        callback(error.message, false)
      }

    }).then((user) => {
      //console.log('user:', user)
      if (user !== undefined) {
        callback(user, true)
      }

    })
}

export const newUserPassword = () => {

  return
  let user = firebase.auth().currentUser;
  let newPassword = "admin8080";

  user.updatePassword(newPassword).then(function () {
    // Update successful.
    console.log("UPDATE OK")
  }).catch(function (error) {
    // An error happened.
    console.log("UPDATE ERROR")
  });

}

export const fetchCurrentUser = (callback) => {
  return firebase.auth()
    .onAuthStateChanged(user => {
      console.log('user:', user)

      if (user) {

        callback(user)

      } else {

        console.log("SING_OUT")
        callback(null)
      }

    })
}

export const singIn = (email, password, callback) => {
  return firebase.auth()
    .signInWithEmailAndPassword(email, password)
    .catch((error) => {
      console.error(error)
      callback(error, false)
    })
    .then((response) => {
      console.log('singin:', response)

      if (response !== undefined) {

        let userId = response.user.uid;

        //Obtém-se o professor do aluno na collection userWithProfessors
        firebase.firestore().collection("userWithProfessors")
          .doc(response.user.uid).get()
          .then(function (response) {

            //console.log(response.data().professor);
            //console.log(response.user.uid);
            //Obtendo informações do usuário
            //Da resposta chega-se ao objeto user e obtém-se seu uid
            firebase.firestore()
              .collection("professors")
              .doc(response.data().professor)
              .collection("users")
              .doc(userId)
              .get()
              .catch((error) => {

                console.error(error)
                callback(error.message, false)

              }).then((doc) => {

                if (doc.exists) {

                  //Retorna user do tipo student
                  let userToReturn = {
                    uid: userId,
                    data: doc.data(),
                  }
                  callback(userToReturn, true)


                } else {
                  callback(
                    { message: "Usuário não cadastrado ou ainda não aprovado" },
                    true)
                }

              })

            //Usuário pode ser um professor
          }).catch(function (error) {

            //Checkando se é professor
            firebase.firestore()
              .collection("professors")
              .doc(response.user.uid)
              .get()
              .catch((error) => {

                //Usuário não é nem aluno nem professor, retorna-se o erro
                console.error(error)
                callback(error.message, false)

              }).then((doc) => {

                if (doc.exists) {

                  //Retorna o user do tipo professor
                  let prof = doc.data();
                  prof.uid = response.user.uid;

                  callback(prof, true)

                } else {

                  //Usuário não é nem aluno nem professor, retorna-se o erro
                  callback(
                    { message: "Usuário não cadastrado ou ainda não aprovado" },
                    true
                  )
                }

              })

          });

      } /*else {
        callback(response, false)
      }*/

    })
}


export const singOut = () => {
  return firebase.auth().signOut()
}

export const saveTrainingToUser = (uidProfessor, training, user, callback) => {

  //atribuindo id do treino aos dados do user
  let date30more = new Date();
  date30more.setDate(date30more.getDate() + 30);
  date30more.setHours(0, 0, 0, 0);

  let userTraining = {
    id: training.id,
    date_update_training: firebase.firestore.FieldValue.serverTimestamp(),
    training_time: date30more,
  }
  user.data.training = userTraining;

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection('users')
    .doc(user.id)
    .update(user.data)
    .then(() => {
      console.log("Document successfully written!");
      callback(userTraining, true);

    }).catch((error) => {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const saveAnamneseToUser = (uidProfessor, user, anamnese, callback) => {

  //atribuindo anamnese ao usuário
  anamnese.date_create = firebase.firestore.FieldValue.serverTimestamp();
  //user.data.anamnese = anamnese;
  user.data.anamnese2 = anamnese;

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("users")
    .doc(user.id)
    .update(user.data)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

//Usuário será inativado, esse atributo será utilizado para limpar o treino no aplicativo
export const inactiveUser = (uidProfessor, userUid, callback) => {

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("inactive_users")
    .doc(userUid)
    .set({})
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

//Usuário será ativado
export const activeUser = (uidProfessor, userUid, callback) => {

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("inactive_users")
    .doc(userUid)
    .delete()
    .then(function () {
      console.log("Document successfully written!");
      callback(true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(false);
    });
}

export const updateUser = (uidProfessor, user, callback) => {

  if (!user.data.training) {
    user.data.training = "";
  }

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("users")
    .doc(user.id)
    .update(user.data)
    .then(function (doc) {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch(function (error) {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const updateUserAttr = (uidProfessor, user, pathUpdate, valueUpdate, callback) => {

  let doUpdate = {};
  doUpdate[pathUpdate] = valueUpdate;

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("users")
    .doc(user.id)
    .update(doUpdate)
    .then((doc) => {
      console.log("Document successfully written!");
      callback(doc, true);

    }).catch((error) => {

      console.error("Error writing document: ", error);
      callback(error, false);
    });
}

export const deleteRequisitionUser = (uidProfessor, user, callback) => {

  return firebase.firestore().collection("professors")
    .doc(uidProfessor)
    .collection("users_requesitions")
    .doc(user.id)
    .delete()
    .then(function () {
      console.log("Document successfully deleted!");
      callback(true);
    }).catch(function (error) {
      console.error("Error removing document: ", error);
      callback(false);
    });
}


// WEBPACK FOOTER //
// src/dao-firebase/user-firebase.js